import React from 'react'
import PropTypes from 'prop-types'
import FormLabel from 'components/labels/FormLabel'
import Label from 'components/labels/Label'

const DataWithLabel = (props) => {
  const {
    label,
    children,
    color,
  } = props
  return (
    <div>
      <FormLabel>{label}</FormLabel>
      <Label style={{ marginLeft: 10, marginTop: 3, fontSize: 12 }} color={color}>
        {children}
      </Label>
    </div>
  )
}

DataWithLabel.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
}

DataWithLabel.defaultProps = {
  label: '',
  children: undefined,
  color: 'black',
}

export default DataWithLabel



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/components/DataWithLabel.js